(function($){
    /**
     * scrollbar
     */
    $(".js-custom-scroll").mCustomScrollbar({
        mouseWheel: {
            enable: true
        }
    });
})(jQuery);